import _toLower from 'lodash/toLower';
import APPCONFIG from '../../constants/Config';
import {
  // REINIT_STATE,
  REINIT_AUTH,
  LOGIN,
  LOGIN_SUCCESS,
  POST_LOGIN,
  POST_LOGIN_BY_MAGIC_LINK,
  POST_LOGOUT,
  LOGOUT,
  POST_RECOVER_PASSWORD,
  GET_RECOVER_PASSWORD_LINK,
  UPDATE_RECOVER_PASSWORD_LINK,
} from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.auth;
const auth = (state = initialSettings, action) => {
  switch (action.type) {
    // case REINIT_STATE:
    //   if (action.target === 'auth') {
    //     return {
    //       ...state,
    //       error: null,
    //       recoverPassword: {
    //         ...initialSettings.recoverPassword,
    //       },
    //     };
    //   }
    //   return state;
    case REINIT_AUTH:
      return {
        ...state,
        error: null,
        loggedIn: false,
        loggedByMagicLink: false,
        token: null,
        recoverPassword: {
          ...initialSettings.recoverPassword,
        },
      };
    /* New authentication pages */
    /* ------------------------ */
    case 'SIGN_UP':
      return {
        ...state,
        signUp: action.status,
      };
    case 'RECOVER_PASSWORD':
      // This action was used to reset or update the recovery status
      // We maintain the object structure to avoid PropTypes warnings
      if (action.status === null) {
        // Reset: restore default values
        return {
          ...state,
          recoverPassword: {
            post: false,
            getLink: false,
            updateLink: false,
          },
        };
      }
      if (action.status === 'GET_LINK') {
        // Success generating a recovery link
        return {
          ...state,
          recoverPassword: {
            ...state.recoverPassword,
            getLink: true,
          },
        };
      }
      if (action.status === 'UPDATED') {
        // Success updating password via the recovery link
        return {
          ...state,
          recoverPassword: {
            ...state.recoverPassword,
            updateLink: true,
          },
        };
      }
      // For other status values, keep the current state
      return state;
    /* ---------------------------- */
    /* End new authentication pages */
    case LOGIN:
      return {
        ...state,
        error: null,
        loggedIn: true,
      };
    /* In use for new login pages only */
    case LOGIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        token: action.token,
      };
    case POST_LOGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case `${POST_LOGIN}_ERROR`:
      return {
        ...state,
        loading: false,
        token: null,
        error: action.error,
      };
    case `${POST_LOGIN}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loggedIn: true,
        token: action.useGraphQL ? action.data.login.jwt : action.data.jwt,
      };
    // ----- POST_LOGIN_BY_MAGIC_LINK ----- //
    case POST_LOGIN_BY_MAGIC_LINK:
      return {
        ...state,
        loading: true,
        loggedByMagicLink: false,
        error: null,
        token: null,
      };
    case `${POST_LOGIN_BY_MAGIC_LINK}_ERROR`:
      return {
        ...state,
        loading: false,
        token: null,
        error: action.error,
      };
    case `${POST_LOGIN_BY_MAGIC_LINK}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loggedByMagicLink: true,
        token: action.data.loginByMagicLink.jwt,
      };
    case POST_LOGOUT:
      return {
        ...state,
        error: null,
      };
    case `${POST_LOGOUT}_ERROR`:
      return {
        ...state,
        error: action.error,
      };
    case `${POST_LOGOUT}_SUCCESS`:
    case LOGOUT:
      return {
        ...state,
        loggedIn: false,
        token: null,
      };
    case POST_RECOVER_PASSWORD:
      return {
        ...state,
        loading: true,
        error: null,
        recoverPassword: {
          ...state.recoverPassword,
          post: false,
        },
      };
    case `${POST_RECOVER_PASSWORD}_ERROR`:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case `${POST_RECOVER_PASSWORD}_SUCCESS`:
      return {
        ...state,
        loading: false,
        recoverPassword: {
          ...state.recoverPassword,
          post: true,
        },
      };
    case GET_RECOVER_PASSWORD_LINK:
      return {
        ...state,
        loading: true,
        error: null,
        recoverPassword: {
          ...state.recoverPassword,
          getLink: false,
        },
      };
    case `${GET_RECOVER_PASSWORD_LINK}_ERROR`:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case `${GET_RECOVER_PASSWORD_LINK}_SUCCESS`:
      return {
        ...state,
        loading: false,
        recoverPassword: {
          ...state.recoverPassword,
          getLink: true,
          result: action.useGraphQL ? _toLower(action.data.checkPasswordRecoveryLink) : null,
        },
      };
    case UPDATE_RECOVER_PASSWORD_LINK:
      return {
        ...state,
        loading: true,
        error: null,
        recoverPassword: {
          ...state.recoverPassword,
          updateLink: false,
        },
      };
    case `${UPDATE_RECOVER_PASSWORD_LINK}_ERROR`:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case `${UPDATE_RECOVER_PASSWORD_LINK}_SUCCESS`:
      return {
        ...state,
        loading: false,
        recoverPassword: {
          ...state.recoverPassword,
          updateLink: true,
        },
      };
    default:
      return state;
  }
};

export default auth;



// WEBPACK FOOTER //
// ./reducers/auth/auth.js